// „Mitteilungszentrum" (Dashboard-Karte) — seit 01.11.2026 nach Themen
// gegliedert (Mails · Verpasste Anrufe · Vorgänge · Chat · Tickets · Freigaben
// · System), jede Zeile genau eine Mail / ein Anruf / eine Mitteilung. Liste und
// Gliederung teilt sich die Karte mit der Glocke (`MitteilungszentrumListe` +
// `clusterNotifications`). Gemeinsamer NotificationContext → Lesen/Leeren wirkt
// synchron mit Glocke + Badge.
// T-364 bleibt: Klick auf eine Zeile öffnet nur, quittiert wird per Haken;
// „Leeren" quittiert alle Mitteilungen (Posteingang/Anrufe sind Live-Status).
import * as React from "react";
import { useNavigate } from "react-router";
import { Alert20Regular, CheckmarkCircle16Regular } from "@fluentui/react-icons";
import { useNotifications } from "../../context/NotificationContext";
import { REFINED } from "../risikoanalyseStep/tokens";
import { DashCard } from "./DashboardShared";
import { MitteilungszentrumListe } from "../notifications/MitteilungszentrumListe";

export const MitteilungszentrumCard: React.FC = () => {
    const navigate = useNavigate();
    const { notifications, markAllRead } = useNotifications();
    const offene = notifications.some((n) => !n.readAt);

    return (
        <DashCard
            title="Mitteilungszentrum"
            icon={<Alert20Regular />}
            right={
                offene ? (
                    <button
                        type="button"
                        onClick={() => void markAllRead()}
                        title="Alle Mitteilungen abhaken"
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 5,
                            border: `1px solid ${REFINED.line}`,
                            background: REFINED.white,
                            borderRadius: 8,
                            cursor: "pointer",
                            color: REFINED.ink2,
                            fontFamily: REFINED.fontUI,
                            fontSize: "0.82rem",
                            fontWeight: 600,
                            padding: "6px 10px",
                        }}
                    >
                        <CheckmarkCircle16Regular /> Leeren
                    </button>
                ) : undefined
            }
        >
            <div style={{ paddingTop: 8 }}>
                <MitteilungszentrumListe variante="karte" onOeffnen={(link) => navigate(link)} />
            </div>
        </DashCard>
    );
};

export default MitteilungszentrumCard;
